export default "__VITE_ASSET__DOGo8t77__"